<template>
  <div class="col-sm-12 col-md">
    <InputWidget
      v-model="model"
      :error="errors"
      id="input-bank_account_iban"
      :label="computedLabel"
      :placeholder="computedPlaceholder"
      @change="inputChange"
      @input="onInput"
      :rules="required ? 'required' : ''"
    />
  </div>
</template>

<script>
import InputWidget from "../../../core/InputWidget";
import BaseInputMixin from "@/mixins/profileInputMixin";

export default {
  name: "BankAccountIban",
  components: {InputWidget},
  mixins: [BaseInputMixin('bank_account.iban')],

  data() {
    return {
      name: 'iban',
      defaultLabel: this.$t("IBAN")
    }
  }
}
</script>

<style scoped>

</style>
